export default {
  apiUrl: process.env.VUE_APP_APIURL,
  // apiUrl: 'api.freefone.app',
  protocol: process.env.VUE_APP_PROTOCOL,
  sip_sever: process.env.VUE_APP_SIP_SERVER || 'freefone1.sip.stage.opentact.org',
  sip_server_port: process.env.VUE_APP_SIP_SERVER_PORT || 5443
}
